export default "__VITE_ASSET__Cboakjgz__"